<template>
	<div class="app" :class="{'electricity-default': themeCode === 'default', 'electricity': themeCode === 'blue'}">
		<div class="energy-content-r-top">
		  <div>
		    <DatePicker v-model="times" format="yyyy-MM-dd" type="daterange" placement="bottom-end" :placeholder="$t('electricity.electricity.543197-0')" style="width: 10vw"></DatePicker>
		  </div>
      <div>
        <Input v-model="deviceCode" clearable :placeholder="$t('electricity.electricity.543197-1')"></Input>
      </div>
      <div>
        <Input v-model="userDeviceName" clearable :placeholder="$t('electricity.electricity.543197-2')"></Input>
      </div>
		  <div>
		    <Button type="primary" @click="inquireClick">{{ $t('electricity.electricity.543197-3') }}</Button>
		  </div>
		  <div>
		    <Button type="success" @click="exportClick">{{ $t('electricity.electricity.543197-4') }}</Button>
		  </div>
		</div>
    <div class="energy-content-r-content">
      <dv-border-box-10 :color="themeCode === 'default' ? ['#46758b', '#46857b'] : ['#092768', '#28449D']" :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.3)'">
        <div class="energy-ranking">
          <div class="map-bottom-content-tab">
            <div class="map-bottom-content-tab-item">{{ $t('electricity.electricity.543197-2') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('electricity.electricity.543197-1') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('electricity.electricity.543197-5') }}(KW·H)</div>
            <!-- <div class="map-bottom-content-tab-item">电流(A)</div>
            <div class="map-bottom-content-tab-item">电压(V)</div>
            <div class="map-bottom-content-tab-item">漏电(mA)</div>
            <div class="map-bottom-content-tab-item">温度(°C)</div> -->
            <div class="map-bottom-content-tab-item tabHandle">{{ $t('electricity.electricity.543197-6') }}</div>
          </div>
          <div class="map-bottom-list">
            <div class="map-bottom-lists" v-if="DeviceLists.length > 0">
              <div class="map-bottom-list-item" v-for="(item) in DeviceLists" :key="item.DeviceCode">
                <div class="map-bottom-list-item-device">{{item.UserDeviceName}}</div>
                <div class="map-bottom-list-item-addr">{{item.DeviceCode}}</div>
                <div class="map-bottom-list-item-date">{{item.Etotal}}</div>
                <!-- <div class="map-bottom-list-item-date">{{item.DianLiu}}</div>
                <div class="map-bottom-list-item-device">{{item.DianYa}}</div>
                <div class="map-bottom-list-item-addr">{{item.LouDian}}</div>
                <div class="map-bottom-list-item-date">{{item.WenDu}}</div> -->
                <div class="map-bottom-list-item-handle">
                  <Button type="success" size="small" @click="detailsClick(item)">{{ $t('electricity.electricity.543197-7') }}</Button>
                </div>
              </div>
            </div>
            <div v-else class="map-right-group-list-none">{{ $t('electricity.electricity.543197-8') }}</div>
          </div>
          <div class="user-top-list-page">
            <Page :total="TotalCount"
            :current="pageIndex"
            :page-size="pageSize"
            @on-change="DeviceChange"
            @on-page-size-change="DeviceSizeChange"
            size="small" show-elevator show-sizer placement="top" show-total/>
          </div>
        </div>
      </dv-border-box-10>
    </div>
    <div class="electricity-spin-view" @click="setPopup('self')" v-if="popupIndex">
      <div class="electricity-model" @click.stop="setPopup()">
        <dv-border-box-12 :color="['#092768', '#28449D']" backgroundColor="rgba(2,10,57,0.7)">
          <div class="electricity-model-view">
            <div class="energy-content-r-top1">
              <div>
                <DatePicker v-model="times" format="yyyy-MM-dd" type="daterange" placement="bottom-end" :placeholder="$t('electricity.electricity.543197-0')" style="width: 10vw"></DatePicker>
              </div>
              <div>
                <Button type="primary" @click="inquireItemClick">{{ $t('electricity.electricity.543197-3') }}</Button>
              </div>
              <div>
                <Button type="success" @click="exportItemClick">{{ $t('electricity.electricity.543197-4') }}</Button>
              </div>
            </div>
            <div class="energy-content-c">
              <div class="energy-ranking-model">
                <div class="map-bottom-content-tab">
                  <div class="map-bottom-content-tab-item1">{{ $t('electricity.electricity.543197-9') }}</div>
                  <div class="map-bottom-content-tab-item1">{{ $t('electricity.electricity.543197-10') }}(KW·H)</div>
                  <!-- <div class="map-bottom-content-tab-item1">电压(V)</div>
                  <div class="map-bottom-content-tab-item1">电流(A)</div>
                  <div class="map-bottom-content-tab-item1">漏电(mA)</div>
                  <div class="map-bottom-content-tab-item1">温度(°C)</div> -->
                </div>
                <div class="map-bottom-list">
                  <div class="map-bottom-lists" v-if="dayDeviceLists.length > 0">
                    <div class="map-bottom-list-item1" v-for="(item, index) in dayDeviceLists" :key="index">
                      <div class="map-bottom-list-item-device">{{item.TheDate | initDate}}</div>
                      <div class="map-bottom-list-item-addr">{{item.Etotal}}</div>
                      <!-- <div class="map-bottom-list-item-date">{{item.DianYa}}</div>
                      <div class="map-bottom-list-item-date">{{item.DianLiu}}</div>
                      <div class="map-bottom-list-item-device">{{item.LouDian}}</div>
                      <div class="map-bottom-list-item-addr">{{item.WenDu}}</div> -->
                    </div>
                  </div>
                  <div v-else class="map-right-group-list-none">{{ $t('electricity.electricity.543197-8') }}</div>
                </div>
                <div class="user-top-list-page">
                  <Page :total="dayTotalCount"
                  :current="dayPageIndex"
                  :page-size="dayPageSize"
                  @on-change="DayDeviceChange"
                  @on-page-size-change="DayDeviceSizeChange"
                  size="small" show-elevator show-sizer placement="top" />
                </div>
              </div>
            </div>
          </div>
        </dv-border-box-12>
      </div>
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie'
  import api from '../../../api/request.js'
	export default {
		data() {
			return {
        times: [],
        deviceCode: '',
        userDeviceName: '',
        pageIndex: 1,
        pageSize: 20,
        DeviceLists: [],
        TotalCount: 0,
        popupIndex: false,
        deviceCodeStr: '',
        dayPageIndex: 1,
        dayPageSize: 10,
        dayDeviceLists: [],
        dayTotalCount: 0,
			  themeCode: '',

      }
    },

    created() {
			let _this = this;
			_this.themeCode = _this.$store.getters.getThemeCode;
		},

    filters: {
      initDate(value) {
        if (!value) return '';
        let list = value.split(' ');
        return list[0];
      },
    },

		mounted() {
      let _this = this;
      // 获取当天时间
      _this.getTiemDate();
      // 获取用电数据
      _this.GetElecData();
		},

		methods: {
      // 获取当天时间
      getTiemDate() {
        let _this = this;
        var date = new Date();
        date.setMonth(date.getMonth()-1);
        var dateString = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

        var dates = new Date();
        var dateStrings = dates.getFullYear() + "-" + (dates.getMonth() + 1) + "-" + dates.getDate();

        _this.times = [dateString, dateStrings];
      },
      GetElecData() {
        if (!Cookies.get('AdminData')) {
          if (window.location.host == 'xed.hxpwr.com') {
            this.$router.push({
              name: 'xed_login'
            })
          } else {
            this.$router.push({
              name: 'login'
            })
          }
          return;
        }
        let _this = this,
          AdminData = JSON.parse(Cookies.get('AdminData')),
          startDt = '',
          endDt = '';

        if (_this.times.length > 0) {
          startDt = _this.formDate(_this.times[0]);
          endDt = _this.formDate(_this.times[1])
        };
        _this.$store.dispatch("setEnergyState", true);
        api({
          //这里是你自己的请求方式、url和data参数
          method: 'get',
          url: `api/YhjStatic/GetElecData?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=${_this.pageIndex}&pageSize=${_this.pageSize}&startDt=${startDt}&endDt=${endDt}&deviceCode=${_this.deviceCode}&userDeviceName=${_this.userDeviceName}`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Authorization": Cookies.get('Token')
          }
        }, 'yhj').then(function(res) {
          _this.$store.dispatch("setEnergyState", false);
          if (res.Success) {
            _this.DeviceLists = res.Data;
            _this.TotalCount = res.TotalCount;
          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        });
      },
      DeviceChange(value) {
        let _this = this;
        _this.pageIndex = value;
        _this.GetElecData();
      },
      DeviceSizeChange(value) {
        let _this = this;
        _this.pageIndex = 1;
        _this.pageSize = value;
        _this.GetElecData();
      },
      // 搜索
      inquireClick() {
        let _this = this;
        _this.pageIndex = 1;
        _this.GetElecData();
      },
      // 导出
      exportClick() {
        let _this = this;
        if (!Cookies.get('AdminData')) {
          if (window.location.host == 'xed.hxpwr.com') {
            this.$router.push({
              name: 'xed_login'
            })
          } else {
            this.$router.push({
              name: 'login'
            })
          }
          return;
        }
        let AdminData = JSON.parse(Cookies.get('AdminData')),
          startDt = '',
          endDt = '';

        if (_this.times.length > 0) {
          startDt = _this.formDate(_this.times[0]);
          endDt = _this.formDate(_this.times[1])
        };
        api({
          //这里是你自己的请求方式、url和data参数
          method: 'get',
          url: `api/YhjStatic/Export_ElecData?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&startDt=${startDt}&endDt=${endDt}&deviceCode=${_this.deviceCode}&userDeviceName=${_this.userDeviceName}`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Authorization": Cookies.get('Token')
          }
        }, 'yhj').then(function(res) {
          if (res.Success) {
            window.location.href = res.Data;
          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        });
      },
      // 时间转换
      formDate(dateForm) {
        if (!dateForm) {
          return "";
        } else {
          var dateee = new Date(dateForm).toJSON();
          var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(
            /\.[\d]{3}Z/, '');
          return date;
        }
      },

      // 详情
      detailsClick(item) {
        let _this = this;
        _this.setPopup('self');
        _this.deviceCodeStr = item.DeviceCode;
        _this.GetElecDataDay();
      },
      // 详情弹窗
      setPopup(type) {
        if (type == 'self') {
          this.popupIndex = !this.popupIndex;
        }
      },
      // 获取用电数据 按天（详情）
      GetElecDataDay() {
        if (!Cookies.get('AdminData')) {
          if (window.location.host == 'xed.hxpwr.com') {
            this.$router.push({
              name: 'xed_login'
            })
          } else {
            this.$router.push({
              name: 'login'
            })
          }
          return;
        }
        this.$store.dispatch("setEnergyState", true);
        let _this = this,
          AdminData = JSON.parse(Cookies.get('AdminData')),
          startDt = '',
          endDt = '';

        if (_this.times.length > 0) {
          startDt = _this.formDate(_this.times[0]);
          endDt = _this.formDate(_this.times[1])
        };
        api({
          //这里是你自己的请求方式、url和data参数
          method: 'get',
          url: `api/YhjStatic/GetElecDataDay?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=${_this.dayPageIndex}&pageSize=${_this.dayPageSize}&startDt=${startDt}&endDt=${endDt}&deviceCode=${_this.deviceCodeStr}`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Authorization": Cookies.get('Token')
          }
        }, 'yhj').then(function(res) {
          _this.$store.dispatch("setEnergyState", false);
          if (res.Success) {
            _this.dayDeviceLists = res.Data;
            _this.dayTotalCount = res.TotalCount;
          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        });
      },
      DayDeviceChange(value) {
        let _this = this;
        _this.dayPageIndex = value;
        _this.GetElecDataDay();
      },
      DayDeviceSizeChange(value) {
        let _this = this;
        _this.dayPageIndex = 1;
        _this.dayPageSize = value;
        _this.GetElecDataDay();
      },
      // 内页搜索
      inquireItemClick() {
        let _this = this;
        _this.dayPageIndex = 1;
        _this.GetElecDataDay();
      },
      // 内页导出
      exportItemClick() {
        let _this = this;
        if (!Cookies.get('AdminData')) {
          if (window.location.host == 'xed.hxpwr.com') {
            this.$router.push({
              name: 'xed_login'
            })
          } else {
            this.$router.push({
              name: 'login'
            })
          }
          return;
        }
        let AdminData = JSON.parse(Cookies.get('AdminData')),
          startDt = '',
          endDt = '';

        if (_this.times.length > 0) {
          startDt = _this.formDate(_this.times[0]);
          endDt = _this.formDate(_this.times[1])
        };
        api({
          //这里是你自己的请求方式、url和data参数
          method: 'get',
          url: `api/YhjStatic/Export_ElecDataDay?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&startDt=${startDt}&endDt=${endDt}&deviceCode=${_this.deviceCodeStr}`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Authorization": Cookies.get('Token')
          }
        }, 'yhj').then(function(res) {
          if (res.Success) {
            window.location.href = res.Data;
          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        });
      },
    }
	}
</script>

<style scoped="scoped" lang="scss">
  /* @import url("./electricity.css"); */
  @import "./electricity_default.scss";
  @import "./electricity.scss";
</style>



// WEBPACK FOOTER //
// src/components/report/electricity/electricity.vue